import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=311d64a1&"
import script from "./ItemSelector.vue?vue&type=script&lang=js&"
export * from "./ItemSelector.vue?vue&type=script&lang=js&"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports